import ProjectsReportFiltersApp from './projects_report_filters_app'

export default {
  ProjectsReportFiltersApp
}